var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.0007 10.8331C11.3814 10.8331 12.5007 9.71382 12.5007 8.33311C12.5007 6.9524 11.3814 5.83311 10.0007 5.83311C8.61994 5.83311 7.50065 6.9524 7.50065 8.33311C7.50065 9.71382 8.61994 10.8331 10.0007 10.8331Z","stroke":"currentColor","strokeWidth":"1.2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M10.0007 18.3331C13.334 14.9998 16.6673 12.015 16.6673 8.33311C16.6673 4.65121 13.6825 1.66644 10.0007 1.66644C6.31875 1.66644 3.33398 4.65121 3.33398 8.33311C3.33398 12.015 6.66732 14.9998 10.0007 18.3331Z","stroke":"currentColor","strokeWidth":"1.2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Pin.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Pin;

Pin.default = Pin;
